import Loop from '@/assets/graphical-elements/loop.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const LoopIcon = ({className}: IconProps) => <Loop className={cn('fill-current', className)} />
